module.exports = __webpack_public_path__ + "static/media/ploni-regular-aaa.06bd2ebd.eot";